import { render } from "./Banner.vue?vue&type=template&id=c9c4c80e"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/Banner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9c4c80e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9c4c80e', __exports__)) {
    api.reload('c9c4c80e', __exports__)
  }
  
  module.hot.accept("./Banner.vue?vue&type=template&id=c9c4c80e", () => {
    api.rerender('c9c4c80e', render)
  })

}


export default __exports__